import { Modals } from "../components/Modals";
import { Table } from "../components/table-pagination-sorting/components/Table";
import { useDoneFetchActions } from "../hooks/useDoneFetchActions";
import { useAppDispatch } from "../store/store";
import { useState, useRef, useEffect, useCallback } from "react";
import { PaginatingAndSortingProps } from "../components/table-pagination-sorting/interfaces/interfaces";
import {
  initialElement,
  propsElementoFabrica,
  tablePaginationRs,
} from "../utils/formsInitialsStates";
import {
  getMaterial,
  getMateriales,
  savetMaterial,
} from "../services/fabricaServices";
import { showMessage } from "../reducers/msgReducer";
import { MaterialForm } from "../components/forms-modals/MaterialForm";

export const ElementoFabrica = () => {
  const doneFetchActions = useDoneFetchActions();
  const dispatch = useAppDispatch();

  const [data, setData] = useState({ count: 0 } as {
    count: number;
    rows: Array<{ [key: string]: any }>;
  });

  const [datosElementos, setDatosElementos] = useState(
    {} as { on: string; data: propsElementoFabrica | undefined }
  );

  const elementFormRef = useRef<{
    handleClick: () => propsElementoFabrica;
    resetForm: () => void;
  }>();
  const handelPagination = useCallback(
    (pagination: PaginatingAndSortingProps) => {
      function searchDataElement(tipe: string, id: number) {
        doneFetchActions(getMaterial(id)).then((resp: propsElementoFabrica) => {
          setDatosElementos({ on: tipe, data: resp });
        });
      }
      doneFetchActions(getMateriales(pagination)).then(
        (data: tablePaginationRs) => {
          
          data.rows = data.rows?.sort((a, b) => (b.estado === true ? 1 : -1)).map((ob) => ({
            ...ob,
            estado:  ob.estado ? (
              <span className="icon-unlocked" style={{ color: '#007bff', fontSize: '1rem' }}></span>
            ) : (
              <span className="icon-lock" style={{ color: '#dc3545', fontSize: '1rem' }}></span>
            ),
            actions: (
              <>
                <button
                  className="btn"
                  onClick={() => searchDataElement("edit", ob.id)}
                >
                  <span className="icon-pencil"></span>
                </button>
              </>
            ),
          }));
          setData(data);
        }
      );
    },
    [doneFetchActions]
  );

  const onSaveModal = () => {
    const elementValues = elementFormRef.current?.handleClick();
    if (elementValues) {
      doneFetchActions(savetMaterial(elementValues)).then((resp) => {
        dispatch(
          showMessage({
            isShow: true,
            title: "Producto registrado con éxito",
            type: "success",
          })
        );
        handelPagination({} as PaginatingAndSortingProps);
        setDatosElementos({ on: "", data: initialElement });
        elementFormRef.current?.resetForm();
      });
    }
  };
  useEffect(() => {
    handelPagination({} as PaginatingAndSortingProps);
  }, [handelPagination]);

  const onCloseModal = () => {
    elementFormRef.current?.resetForm();
    setDatosElementos({ ...datosElementos, on: "" });
  };

  const titles = [
    { title: "Nombre", sort: "nombre" },
    { title: "Unidad de medida", sort: "unidad_medida" },
    { title: "Estado", name: "estado" },
    { title: "Acciones", name: "actions" },
    // { title: "precio por unidad", sort: "precio_unidad" },
  ];
  
  
  return (
    <div>
      <div className="d-flex justify-content-center pt-4">
        <h4 className="align-self-end">Fabricación de Productos</h4>
      </div>
      <div className="d-flex justify-content-end pb-4">
        <div className="align-self-end">
          <button
            onClick={() => {
              setDatosElementos({ on: "add", data: undefined });
            }}
            type="button"
            className="btn btn-primary btn-rounded mb-4"
          >
            Crear Producto
          </button>
        </div>
      </div>
      <div></div>
      <Table
        dataTable={{ ...data, titles, limit: 100 }}
        onChange={handelPagination}
      />
      <Modals
        title="Crear nuevo Producto"
        onSave={onSaveModal}
        onClose={onCloseModal}
        show={!!datosElementos.on}
      >
        <MaterialForm
          ref={elementFormRef}
          data={datosElementos.data}
          on={datosElementos.on}
        />
      </Modals>
    </div>
  );
};
